/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

// ! Infelizmente esse componente se repete de forma semelhante umas 3 vezes em todo o projeto ADM e MAP view
// TODO verificar se não tem como unificar e colocar na pasta raiz

/**
 * Estilização do componente Navigation
 */
export const Navigation = styled.nav`
  margin: 24px 0;
  position: sticky;
  z-index: 5;
  border-bottom: 1px solid #ccc;
  top: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  padding: 5px 0 5px 12px;
  background: #fff;

  @media (max-width: 768px) {
    margin-top: 0px;
  }

  > button {
    display: inline-block;
    padding: 5px 10px;
    margin: 0 5px;
    flex: 0 1 auto;
    outline: 0;
    border: none;
    background: transparent;
    opacity: 0.8;
    transition: 0.5s all;
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;

    &:hover {
      opacity: 1;
    }

    &:first-child {
      margin-left: 0;
    }

    &:disabled {
      opacity: 0.3;
    }

    &.active {
      opacity: 1;
      color: #3C71DD;
    }
  }
`;

/**
 * Estilização do componente Line
 */
export const Line = styled.div`
  position: absolute;
  height: 4px;  
  background: ${({ background }) => (background ? background : '#3c71dd')};
  z-index: 4;
  transition: 0.5s all;
  top: ${(props) => `${props.top}px`};
  left: ${(props) => `${props.left}px`};
  width: ${(props) => `${props.width}px`};
`;
